export default __webpack_public_path__ + "static/media/10.2a13e2b0.png";